import { render, staticRenderFns } from "./NodeEditor.vue?vue&type=template&id=610f063c"
import script from "./NodeEditor.vue?vue&type=script&lang=js"
export * from "./NodeEditor.vue?vue&type=script&lang=js"
import style0 from "./NodeEditor.vue?vue&type=style&index=0&id=610f063c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports